import { z } from "zod";
import { DTOStorybookEntryListResponse, DTOStorybookEntryReplaceAction } from "../../dto";
import { RequestExecutor } from "../../transport/request-executor";

export class StorybookEntriesEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(dsId: string) {
    return this.requestExecutor.json(`/design-systems/${dsId}/versions/head/storybook`, DTOStorybookEntryListResponse);
  }

  replace(dsId: string, entryId: string) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/head/storybook/${entryId}`,
      DTOStorybookEntryReplaceAction,
      { method: "PUT" }
    );
  }

  delete(dsId: string, entryId: string) {
    return this.requestExecutor.json(`/design-systems/${dsId}/versions/head/storybook/${entryId}`, z.any(), {
      method: "DELETE",
    });
  }
}
